import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@material-ui/core/'
import { ChatAccordion } from 'components/UI/'
import './index.scss'

const LeftContainer = () => {
  const { chatSchedules, chatRequests, chatMeetings } = useSelector(({ chat }) => chat)
  const { user } = useSelector(({ session }) => session)

  return (
    <Grid className='leftContainerWrapper'>
      <ChatAccordion
        title='Scheduled meetings'
        id='received-header'
        controls='received-content'
        panel='panel1'
        // goTo={goTo}
        page='2'
        user={chatSchedules}
        // discusStory={discusStoryHandler}
        avtor={user?.user?.uuid}
        path='meeting-scheduled'
        description='There are no scheduled meetings yet. Explore the stories and find people to meet.'
      />
      <ChatAccordion
        title='Received meeting requests'
        id='received-header'
        controls='received-content'
        panel='panel2'
        // goTo={goTo}
        page='2'
        user={chatRequests?.filter(item => item?.authorUuid !== user?.user?.uuid)}
        // discusStory={discusStoryHandler}
        avtor={user?.user?.uuid}
        path='meeting-requests'
        description="You haven't received any meeting requests. Share your stories to connect with people."
      />
      <ChatAccordion
        title='Meeting chats'
        id='received-header'
        controls='received-content'
        panel='panel3'
        // goTo={goTo}
        page='2'
        user={chatMeetings}
        // discusStory={discusStoryHandler}
        avtor={user?.user?.uuid}
        path='meeting-chat'
        description="You haven't started chatting with people on tellMe. We know you'll find someone to talk to here! Read the stories and initiate communication."
      />
    </Grid>
  )
}

export default LeftContainer
